const numeral = require('numeral');
export default {
  formatPrice: function(price) {
    return numeral(price).format('0,0.00');
  },
  convertToDouble: function(text) {
    return numeral(text.toString().replace(/,/g , ".")).value()
  }
}



// WEBPACK FOOTER //
// ./src/utils/PriceUtils.js